export default "__VITE_ASSET__ebXwaoYl__"